'use client';

import { AnalyticsProvider as ChimeAnalyticsProvider } from '@1debit/analytics';
import { analyticsHandler, initConsentGate } from '../analytics';
import { useEffect, useRef, useState } from 'react';
import { usePathname } from 'next/navigation';
import { toSnakeCase } from 'utils/formatters';

const ROOT_LAYOUT_PAGE_NAME = 'chime';

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const [formattedPageName, setFormattedPageName] = useState<string>('');
  const lastResolvedPageName = useRef(ROOT_LAYOUT_PAGE_NAME);
  const pathname = usePathname();

  useEffect(() => {
    initConsentGate();
  }, []);

  useEffect(() => {
    const updatePageName = () => {
      const pageName = toSnakeCase(document.title);
      if (!pageName || pageName === ROOT_LAYOUT_PAGE_NAME || pageName === lastResolvedPageName.current) return false;

      // Page name needs to be in snake_case or else the event will be dropped by Analytics SDK
      lastResolvedPageName.current = pageName;
      setFormattedPageName(pageName);
      return true;
    };

    if (updatePageName()) return;

    const titleObserver = new MutationObserver(() => {
      if (updatePageName()) titleObserver.disconnect();
    });
    titleObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    return () => titleObserver.disconnect();
  }, [pathname]);

  return (
    <ChimeAnalyticsProvider handler={analyticsHandler} pageName={formattedPageName}>
      {children}
    </ChimeAnalyticsProvider>
  );
}
